
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 29 28","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1542_10056)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.464 3.936l4.828 4.635 5.332 5.107c.281.27.393.612.425 1.005.305 3.676.26 7.199 0 10.59-.016 1.453-.958 2.28-2.35 2.376-6.238.424-12.386.512-18.377 0-1.243.008-2.133-1.056-2.262-2.43-.331-3.531-.473-7.05 0-10.536.053-.391.143-.735.425-1.003l5.317-5.107 4.829-4.635a1.312 1.312 0 011.831 0l.002-.002zm-.716 7.806c3.36 0 6.085 2.796 6.085 6.244 0 3.447-2.725 6.243-6.085 6.243s-6.085-2.796-6.085-6.243c0-3.448 2.725-6.244 6.085-6.244zm-1.033 2.49c0-.564.447-1.022.996-1.022.549 0 .995.458.995 1.021v2.675h2.607c.549 0 .996.458.996 1.021a1.01 1.01 0 01-.996 1.021h-2.607v2.675a1.01 1.01 0 01-.995 1.022 1.01 1.01 0 01-.996-1.022v-2.675h-2.607a1.01 1.01 0 01-.995-1.02c0-.564.446-1.022.995-1.022h2.607V14.23zm14.97-1.464c.4.383.421 1.027.048 1.437a.974.974 0 01-1.401.048L14.76 2.174c-.112-.09-.199-.14-.258-.137-.057 0-.144.048-.258.143L1.67 14.23a.977.977 0 01-1.405-.053 1.04 1.04 0 01.051-1.442L12.891.688a.664.664 0 01.076-.072c.483-.41.992-.612 1.527-.614.533-.002 1.04.196 1.513.587l-.002.002a.67.67 0 01.055.05L28.683 12.77l.002-.002z","fill":"#0E6199"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1542_10056"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h29v28H0z"}})])])])
          )
        }
      }
    